































import { Component, Vue, Watch } from "vue-property-decorator";
import BusinessInfo from "./BusinessInfo.vue";
import BrandInfo from "./BrandInfo.vue";
import ExtraInfo from "./ExtraInfo.vue";
import * as api from "@/service/step-five";
import { businessInfo } from "../testData";
import { State } from "vuex-class";

@Component({
  components: { BusinessInfo, BrandInfo, ExtraInfo },
})
export default class StepsFive extends Vue {
  @State bidType!: number;
  form: any = {
    store_list: [{}],
    brand_list: [],
    contract_list: [],
  };
  loading = false;

  get brandData() {
    return { brand_list: this.form.brand_list };
  }

  get catList() {
    return this.form.store_list
      .reduce((arr: any[], store: any) => arr.concat(store.cat_list || []), [])
      .reduce(
        (res: any[], cat: any) =>
          res.some((item) => item.cat_id === cat.cat_id)
            ? res
            : res.concat(cat),
        []
      );
  }

  @Watch("catList")
  onCatListChange(list: any[], oldList: any[], firstRender?: boolean) {
    // 删除经营类目后，移除品牌关联的类目id
    if (list.length < oldList.length || firstRender) {
      this.form.brand_list.forEach((brand: any) => {
        brand.relate_cat_ids = brand.relate_cat_ids.filter((id: any) =>
          list.some((item) => item.cat_id === id)
        );
      });
    }
  }

  async created() {
    this.form = await api.queryManageInfo();
    this.onCatListChange(this.catList, [], true);
  }

  async submit() {
    try {
      await (this.$refs.business as any).validate();
    } catch {
      this.$message.error("请完善业务信息内的必填信息");
      throw new Error("校验失败");
    }
    try {
      await (this.$refs.brand as any).validate();
    } catch {
      this.$message.error("请完善品牌信息内的必填信息");
      throw new Error("校验失败");
    }
    if (
      this.form.brand_list.some((brand: any) => !brand.relate_cat_ids?.length && brand.brand_type != 3)
    ) {
      this.$message.error("请在品牌信息中关联经营类目");
      return;
    }
    let names = this.form.store_list.map((item:any) => item["sname"]);
    let nameSet = new Set(names);
    if (nameSet.size != names.length) {
      this.$message.error("存在相同的经营名称，请修改后重新提交");
      return;
    }
    console.log(
      "🚀 ~ file: index.vue ~ line 101 ~ StepsFive ~ submit ~ this.form",
      this.form
    );

    this.loading = true;
    try {
      await api.saveStoreInfo(this.form);
      this.$emit("forward");
    } catch {}
    this.loading = false;
  }
  doTest() {
    const { NODE_ENV, TARGET } = process.env;
    if (NODE_ENV === "development" || TARGET === "test-build") {
      this.form = { ...this.form, ...businessInfo(this.bidType) };
    }
  }
}
